import TagManager from "react-gtm-module";

function NotificationsPopUp({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "view_updated_results",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default NotificationsPopUp;
